import { useCallback } from 'react';
import _ from 'lodash';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import Translator from '../../helpers/Translator';
import minions from '../../../../minions/minions';
import colors from '../../../../constants/colors';

export default function AppFileUploaderList({ values, setFieldValue, urlsAvaliable = [], showIconWhenEMpty = true, noFileText }) {
  const toggleRemoveFile = useCallback((fileName) => {
    const updateRemoveFiles = values.deletedFiles;

    if (updateRemoveFiles.includes(fileName)) {
      setFieldValue(
        'deletedFiles',
        updateRemoveFiles.filter((fn) => fn !== fileName)
      );
    } else {
      updateRemoveFiles.push(fileName);
      setFieldValue('deletedFiles', updateRemoveFiles);
    }
  }, [values]);

  console.log(urlsAvaliable)

  return (urlsAvaliable && Object.keys(urlsAvaliable).length > 0) || values?.files?.length > 0 ? (
    <>
      <FileList $urls>
        {urlsAvaliable && _.map(urlsAvaliable, (file, i) => (
          <li
            key={i}
            title={
              values?.deletedFiles?.includes(i)
                ? ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="click-restore"
                    />
                  )
                : ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="click-mark-delete"
                    />
                  )
            }
            onClick={() => toggleRemoveFile(i)}
          >
            <AppRemixIcon
              className="pointer mr-3"
              icon="delete-bin"
              color={
                values?.deletedFiles?.includes(i) ? colors.grey400 : colors.danger
              }
            />
            {minions.files.fileIcon(
              i,
              true,
              values?.deletedFiles?.includes(i) ? colors.grey400 : null,
              'mr-2'
            )}
            <FileName $isRemoved={values?.deletedFiles?.includes(i)}>
              {file.name}
            </FileName>
          </li>
        ))}
      </FileList>
      {values?.files && (
        <FileList $urls={false}>
          {_.map(values?.files, (file) => (
            <li
              key={file.name}
              onClick={() =>
                setFieldValue(
                  'files',
                  [...values?.files].filter((f) => f.name !== file.name)
                )
              }
            >
              <AppRemixIcon className="pointer mr-3" icon="delete-bin" />
              {minions.files.fileIcon(file.name, true, null, 'mr-2')}
              {file.name}
            </li>
          ))}
        </FileList>
      )}
    </>
  ) : (
    <>
        {showIconWhenEMpty ? (
            <AppNoInfo
                icon={<AppRemixIcon icon="cloud-off" color="#ccc" size={34} />}
                text={
                    noFileText || (
                    <Translator file="admin" name="general.no-files-available" />
                    )
                }
            />
        ) : null}
    </>
  );
}

const FileList = styled.ul`
  list-style: none;
  margin: 0;
  padding-left: 6px;
  overflow-y: auto;
  max-height: 250px;
  li:hover {
    background-color: rgba(232, 232, 232, 0.8);
  }
  li {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.grey300};
    padding: 8px 0;
    span {
      font-size: 12px;
      color: ${colors.primary};
    }
  }
  li:first-child {
    border-top: 0;
  }
`;

const FileName = styled.span`
  text-decoration: ${(props) => (props.$isRemoved ? 'line-through' : 'unset')};
`;
